module.exports = {
  getParam(val) {
    var result = "",
      tmp = [];
    location.search
      .substr(1)
      .split("&")
      .forEach(function (item) {
        tmp = item.split("=");
        if (tmp[0] === val) result = decodeURIComponent(tmp[1]);
      });
    return result;
  },
  loadStoryblokBridge(cb) {
    const existingScript = document.getElementById("sb-script");
    let token = this.getParam("token");
    if (token) {
      window.localStorage.setItem("SBToken", token);
    } else {
      token = window.localStorage.getItem("SBToken");
    }

    if (!existingScript) {
      let script = document.createElement("script");
      script.type = "text/javascript";
      script.src = `//app.storyblok.com/f/storyblok-latest.js?t=${token}`;
      script.id = "sb-script";
      script.onload = cb;
      document.getElementsByTagName("head")[0].appendChild(script);
    } else {
      cb();
    }
  }
}
